import React, { useState } from 'react';
import styled from 'styled-components';
import { colors } from '../../styles/variables';

const CurriculumSection = styled.section`
  padding: 80px 24px;
  background-color: ${colors.lightGray};
`;

const SectionContainer = styled.div`
  max-width: 1200px;
  margin: 0 auto;
`;

const SectionTitle = styled.h2`
  font-size: 36px;
  font-weight: 700;
  color: ${colors.primary};
  margin-bottom: 16px;
`;

const SectionSubtitle = styled.p`
  font-size: 18px;
  color: ${colors.textGray};
  margin-bottom: 48px;
`;

const CurriculumList = styled.div`
  margin-bottom: 48px;
`;

const Module = styled.div`
  margin-bottom: 32px;
`;

const ModuleHeader = styled.div`
  background-color: ${colors.white};
  padding: 16px 24px;
  border-radius: 8px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);
  margin-bottom: ${props => props.isOpen ? '16px' : '0'};
  cursor: pointer;
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

const ModuleTitle = styled.h3`
  font-size: 20px;
  font-weight: 700;
  color: ${colors.primary};
`;

const ModuleArrow = styled.div`
  font-size: 20px;
  transition: transform 0.3s;
  transform: ${props => props.isOpen ? 'rotate(180deg)' : 'none'};
`;

const ModuleContent = styled.div`
  padding: 0 24px;
  display: ${props => props.isOpen ? 'block' : 'none'};
`;

const ModuleDescription = styled.p`
  font-size: 16px;
  color: ${colors.textGray};
  margin-bottom: 16px;
`;

const LessonList = styled.ul`
  list-style: none;
`;

const LessonItem = styled.li`
  display: flex;
  align-items: center;
  padding: 12px 0;
  border-bottom: 1px solid rgba(0, 0, 0, 0.05);
`;

const LessonIcon = styled.div`
  width: 24px;
  height: 24px;
  background-color: rgba(70, 117, 249, 0.1);
  color: ${colors.secondary};
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 16px;
  font-size: 12px;
`;

const LessonTitle = styled.div`
  font-size: 16px;
  color: ${colors.tertiary};
`;

const CourseCurriculum = ({ subtitle, modules }) => {
  const [openModules, setOpenModules] = useState({});

  const toggleModule = (moduleId) => {
    setOpenModules(prev => ({
      ...prev,
      [moduleId]: !prev[moduleId]
    }));
  };

  return (
    <CurriculumSection id="curriculum">
      <SectionContainer>
        <SectionTitle>커리큘럼</SectionTitle>
        <SectionSubtitle>{subtitle}</SectionSubtitle>
        
        <CurriculumList>
          {modules.map((module, index) => (
            <Module key={index}>
              <ModuleHeader 
                isOpen={openModules[index]} 
                onClick={() => toggleModule(index)}
              >
                <ModuleTitle>{module.title}</ModuleTitle>
                <ModuleArrow isOpen={openModules[index]}>▼</ModuleArrow>
              </ModuleHeader>
              <ModuleContent isOpen={openModules[index]}>
                <ModuleDescription>{module.description}</ModuleDescription>
                <LessonList>
                  {module.lessons.map((lesson, lessonIndex) => (
                    <LessonItem key={lessonIndex}>
                      <LessonIcon>{lessonIndex + 1}</LessonIcon>
                      <LessonTitle>{lesson}</LessonTitle>
                    </LessonItem>
                  ))}
                </LessonList>
              </ModuleContent>
            </Module>
          ))}
        </CurriculumList>
      </SectionContainer>
    </CurriculumSection>
  );
};

export default CourseCurriculum;